import React, { useContext } from 'react'
import * as S from './styles'
import Header from '../../components/Header'
import { Outlet } from 'react-router-dom'

function dashboard() {
  return (
    <S.Container>
      <Header />
      <S.Content>
        <Outlet />
      </S.Content>
    </S.Container>
  )
}

export default dashboard
